import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import MainCard from 'components/MainCard';

export function SummaryCardsSkeleton({ count = 4 }) {
  return (
    <Grid container spacing={2}>
      {[...Array(count)].map((_, idx) => (
        <Grid key={idx} size={{ xs: 12, sm: 6, md: 4, lg: 12 / count >= 2.4 ? 12 / count : 3 }}>
          <MainCard>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ width: '60%' }}>
                <Skeleton variant="text" width="80%" height={20} />
                <Skeleton variant="text" width="100%" height={40} sx={{ my: 0.5 }} />
                <Skeleton variant="text" width="50%" height={16} />
              </Box>
              <Skeleton variant="rectangular" width={48} height={48} sx={{ borderRadius: 2 }} />
            </Box>
          </MainCard>
        </Grid>
      ))}
    </Grid>
  );
}

export function ChartSkeleton() {
  return (
    <MainCard>
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width="30%" height={24} />
        <Skeleton variant="text" width="50%" height={16} />
      </Box>
      <Skeleton variant="rectangular" width="100%" height={260} sx={{ borderRadius: 2 }} />
    </MainCard>
  );
}

export function TableSkeleton() {
  return (
    <MainCard contentSX={{ p: 0 }}>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Skeleton variant="text" width="20%" height={32} />
        <Skeleton variant="rectangular" width="150" height={36} sx={{ borderRadius: 1 }} />
      </Box>
      <Box sx={{ px: 2, pb: 2 }}>
        <Skeleton variant="rectangular" width="100%" height={44} sx={{ mb: 1, borderRadius: 1 }} />
        {[...Array(5)].map((_, idx) => (
          <Skeleton key={idx} variant="rectangular" width="100%" height={52} sx={{ mb: 1, borderRadius: 1 }} />
        ))}
      </Box>
    </MainCard>
  );
}

/**
 * Skeleton Loader states for various layouts
 */
export default function LoadingState({ type = 'all', cardCount = 4 }) {
  if (type === 'cards') return <SummaryCardsSkeleton count={cardCount} />;
  if (type === 'chart') return <ChartSkeleton />;
  if (type === 'table') return <TableSkeleton />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
      <SummaryCardsSkeleton count={cardCount} />
      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <ChartSkeleton />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ChartSkeleton />
        </Grid>
      </Grid>
      <TableSkeleton />
    </Box>
  );
}
